import BackButton from "../BackButton";

const PrivacyPolicy = () => {
    const currentDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    return (
        <div className="privacy-policy-container" style={{
            maxWidth: '800px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: 'Arial, sans-serif',
            lineHeight: '1.6'
        }}>
            <div>
                <title>Privacy Policy of WholesaleMart</title>
                <meta name="description" content="Privacy policy for our eCommerce mobile application" />
            </div>

            <h1 style={{ color: '#2c3e50', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
                Privacy Policy for WholesaleMart
            </h1>
            <p style={{ fontStyle: 'italic', color: '#7f8c8d' }}>Last updated: {currentDate}</p>

            <section>
                <h2 style={{ color: '#3498db', marginTop: '25px' }}>1. Information We Collect</h2>
                <h3>1.1 Personal Information</h3>
                <p>When you use our eCommerce App, we may collect:</p>
                <ul>
                    <li>Account information (name, email address, phone number)</li>
                    <li>Payment information (processed through secure payment gateways)</li>
                    <li>Shipping and billing addresses</li>
                    <li>Purchase history and preferences</li>
                </ul>

                <h3>1.2 Automatically Collected Information</h3>
                <p>The App may collect certain information automatically:</p>
                <ul>
                    <li>Device information (model, OS version, device identifiers)</li>
                    <li>Usage data (features accessed, time spent in app)</li>
                    <li>Location information (if enabled)</li>
                </ul>
            </section>

            <section>
                <h2 style={{ color: '#3498db', marginTop: '25px' }}>2. How We Use Your Information</h2>
                <p>We use the collected information to:</p>
                <ul>
                    <li>Process and fulfill your orders</li>
                    <li>Provide customer support</li>
                    <li>Improve and personalize your experience</li>
                    <li>Develop new features</li>
                    <li>Prevent fraud and enhance security</li>
                </ul>
            </section>

            <section>
                <h2 style={{ color: '#3498db', marginTop: '25px' }}>3. Data Sharing</h2>
                <h3>3.1 Service Providers</h3>
                <p>We may share information with:</p>
                <ul>
                    <li>Payment processors (Stripe, PayPal, etc.)</li>
                    <li>Shipping carriers</li>
                    <li>Analytics providers (Google Analytics)</li>
                </ul>

                <h3>3.2 Legal Compliance</h3>
                <p>We may disclose information when required by law.</p>
            </section>

            <section>
                <h2 style={{ color: '#3498db', marginTop: '25px' }}>4. Google Maps API</h2>
                <p>
                    Our App uses Google Maps API. By using our App, you agree to Google's
                    <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" style={{ color: '#2980b9', margin: '0 5px' }}>
                        Terms of Service
                    </a>
                    and
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#2980b9', margin: '0 5px' }}>
                        Privacy Policy
                    </a>.
                </p>
            </section>

            <section>
                <h2 style={{ color: '#3498db', marginTop: '25px' }}>5. Your Rights</h2>
                <p>You have the right to:</p>
                <ul>
                    <li>Access and update your information</li>
                    <li>Request deletion of your data</li>
                    <li>Opt-out of marketing communications</li>
                    <li>Disable location services</li>
                </ul>
            </section>

            <section>
                <h2 style={{ color: '#3498db', marginTop: '25px' }}>6. Data Security</h2>
                <p>We implement security measures including:</p>
                <ul>
                    <li>SSL/TLS encryption</li>
                    <li>Secure storage</li>
                    <li>Regular security audits</li>
                </ul>
            </section>

            <section>
                <h2 style={{ color: '#3498db', marginTop: '25px' }}>7. Contact Us</h2>
                <p>For privacy questions, contact us at:</p>
                <p>
                    Email: <a href="mailto:p1i.srisaiandco@gmail.com" style={{ color: '#2980b9' }}>p1i.srisaiandco@gmail.com</a><br />
                    Address: Garuda Enclave, Near Zoo Park, Tirupathi - 517501
                </p>
            </section>

            <div style={{ marginTop: '40px' }}>
                <BackButton />
            </div>
        </div>
    );
};

export default PrivacyPolicy;